@import '../../shared';

:host {
  display: block;
  background-color: var(--rds-body-color-background);
}

#loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--rds-body-color-background);
}

#loading rds-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
